import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SearchForm from "components/SearchForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMachineAdminThunk } from "store/reducers/accounts";
import {
  assignMachineAdminThunk,
  removeMachineAdminThunk,
} from "store/reducers/machine_func/machineAssignments";

const AssignMachineAdminDialog = ({ open, handleClose, machine_id }) => {
  const [ setSearch] = React.useState("");
  const dispatch = useDispatch();
  const admins = useSelector((state) => state.accounts.machineAdmins);
  const {
    machineAdminRemoveLoading,
    machineAdminAssignMentLoading,
  } = useSelector((state) => state.vending);

  const machine = useSelector((state) => state.vending.machines).find(
    (item) => item.id === machine_id
  );
  useEffect(() => {
    if (open) {
      dispatch(getMachineAdminThunk());
    }
  }, [dispatch, open]);

  const assignAdmin = (machine_admin) => {
    dispatch(assignMachineAdminThunk({ machine_admin, machine: machine_id }));
  };
  const removeAdmin = (machine_admin) => {
    dispatch(removeMachineAdminThunk({ machine_admin, machine: machine_id }));
  };

  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Select Store Admins to add"
    >
      <Box paddingX={2}>
        <SearchForm
          hint="Search Store Admins"
          submitSearch={setSearch}
          sx={{ marginY: 2 }}
        />
      </Box>
      {admins.length > 0 ? (
        <>
          {admins
            .filter((item) => item.profile !== null)
            .map((admin) => (
              <Stack
                justifyContent="space-between"
                margin={2}
                direction="row"
                alignItems="center"
                key={admin.id}
              >
                <Box>
                  <Typography variant="body1">
                    {admin.profile.first_name} {admin.profile.last_name}
                  </Typography>
                  <Typography variant="body2" color="gray">
                    @{admin.username}
                  </Typography>
                </Box>
                {machine?.machine_admins?.find(
                  (item) => item.id === admin.profile.id
                ) ? (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={machineAdminRemoveLoading[admin.profile.id]}
                    onClick={() => removeAdmin(admin.profile)}
                    color="error"
                  >
                    Remove
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={machineAdminAssignMentLoading[admin.profile.id]}
                    onClick={() => assignAdmin(admin.profile)}
                  >
                    Assign
                  </LoadingButton>
                )}
              </Stack>
            ))}
        </>
      ) : (
        <Typography textAlign="center"> No items </Typography>
      )}
    </CustomDialog>
  );
};

export default AssignMachineAdminDialog;
